import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

type Settings = Record<string, any>;

/**
 * @deprecated: use SettingsProvider instead
 * @see `@kiosk/src/Settings.jsx`
 */
export const selectJsonSetting = (key: string, tenantSettings: Settings, storeSettings: Settings, def = {}) => {
  const storeRaw = get(storeSettings, key);
  const tenantRaw = get(tenantSettings, key);
  let storeSettingValue;
  let tenantSettingValue;

  try {
    storeSettingValue = JSON.parse(storeRaw);
  } catch (e) {
    storeSettingValue = def;
  }

  try {
    tenantSettingValue = JSON.parse(tenantRaw);
  } catch (e) {
    tenantSettingValue = def;
  }

  if (!isEmpty(storeSettingValue)) {
    return storeSettingValue;
  }

  if (!isEmpty(tenantSettingValue)) {
    return tenantSettingValue;
  }

  return def;
};
